import gql from 'graphql-tag'

export const GET_COIN_TRANSACTION_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
		$query: String
  ) {
    getCoinTransactionPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
				query: $query
      }
    ) {
      hasMore
      total
      items {
        id
				client {
					uid
					fullName
					telNumber
				}
				amount
				type
				isIncome
				createdAt
      }
    }
  }
`;

export const GET_COIN_TRANSACTION_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getCoinTransaction (
      data: {
        id: $id
      }
    ) {
      id
			client {
				uid
				fullName
				telNumber
			}
			amount
			type
			isIncome
			createdAt
    }
  }
`;
